import { AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component, DoCheck, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserService } from '@services/user.service';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { NotificationService } from '@services/notification.service';
import { WebErrorService } from '@services/webError.service';
import { customValidationService } from 'src/app/shared/custom.validator';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-assign-privileges',
  templateUrl: './assign-privileges.component.html',
  styleUrls: ['./assign-privileges.component.scss']
})
export class AssignPrivilegesComponent implements OnInit, DoCheck, AfterContentChecked {
  rolesForm: FormGroup;
  roles: any;
  roleId: any;
  roleName: any;
  displayedColumns: string[] = ['Feature', 'FullControl', 'edit', 'readonly'];
  @ViewChild(MatTable) table: MatTable<any>;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  isHidden = false;
  videoLink: any = '../../../assets/video/test-delivery.mp4'
  constructor(private router: Router,
    private routerstate: ActivatedRoute,
    private webErrorService: WebErrorService,
    private notificationServices: NotificationService,
    private UserService: UserService,
    private fb: FormBuilder,
    public translate: TranslateService,
    private changeDetectorRefs: ChangeDetectorRef) {
    this.roleForm();
  }

  ngOnInit(): void {
    this.routerstate.paramMap.subscribe(data => {
      this.roleId = data.get('id');
    });

    this.UserService.getFeatures().subscribe((data) => {
      const Features = data.Features.map((n, i) => {
        return {
          ...n,
          [`fullcontrol`]: 0,
          [`updatecontrol`]: 0,
          [`readonlycontrol`]: 0,
        }
      }, (error: any) => {
        this.webErrorService.handleAPIErrors(error);
      });

      this.roles = new MatTableDataSource(Features);

      if (this.roleId != null) {
        this.UserService.getRoleById(this.roleId).subscribe((data) => {
          this.roleName = data.data[0].name;
          this.rolesForm.controls['roleName'].setValue(data.data[0].name.trim());
          this.rolesForm.controls['roleDescription'].setValue(data.data[0].description.trim());

          this.roles.data.forEach(element => {
            data.data[0].assignPriviledges.forEach((e) => {
              if (element.objecttypeid == e.featureid) {
                if (e.fullcontrol == true) {
                  element.fullcontrol = e.fullcontrol == true ? 1 : 0,
                    element.updatecontrol = e.updatecontrol == true ? 0 : 0,
                    element.readonlycontrol = e.readonlycontrol == true ? 0 : 0
                } else if (e.updatecontrol == true) {
                  element.fullcontrol = e.fullcontrol == true ? 0 : 0,
                    element.updatecontrol = e.updatecontrol == true ? 2 : 0,
                    element.readonlycontrol = e.readonlycontrol == true ? 0 : 0
                } else if (e.readonlycontrol == true) {
                  element.fullcontrol = e.fullcontrol == true ? 0 : 0,
                    element.updatecontrol = e.updatecontrol == true ? 0 : 0,
                    element.readonlycontrol = e.readonlycontrol == true ? 3 : 0
                }
              }
            })
          });
          this.roles = new MatTableDataSource(this.roles.data);
        }, (error: any) => {
          this.webErrorService.handleAPIErrors(error);
        });
      }
    });
  }

  ngAfterViewInit(): void {
    document.onclick = (args: any) : void => {
      if(args.target.className != 'trainingIcon') {
        this.isHidden = false;
      }
    }
  }

  open_in_new_window(features, link) {
    var new_window;
    if(features !== undefined && features !== '') {
      new_window = window.open('', '_blank', features);
    }
    else {
      new_window = window.open('', '_blank');
    }

    let video = '<video controls controlsList="nodownload" style="width: 100%; height: 100vh;"><source src="' + link + '" type="video/mp4" /></video>'

    if(link !== null && link !== '') {
      new_window.document.write('<!doctype html><html><head><title>Video Player</title><meta charset="UTF-8" /></head><body style="padding: 0; margin: 0;" oncontextmenu="return false">' + video + '</body></html>');
    }
  }

  ngAfterContentChecked() {
    this.changeDetectorRefs.detectChanges();
  }
  ngDoCheck(): void {
    this.changeDetectorRefs.detectChanges();
  }

  clicked(row, type, event) {
    if (type == 'fullcontrol') {
      if (event.target.checked) {
        row.fullcontrol = 1;
        row.updatecontrol = 0;
        row.readonlycontrol = 0;
      } else {
        row.fullcontrol = 0;
        row.updatecontrol = 0;
        row.readonlycontrol = 0;
      }
    }
    if (type == 'updatecontrol') {
      if (event.target.checked) {
        row.fullcontrol = 0;
        row.updatecontrol = 2;
        row.readonlycontrol = 0;
      } else {
        row.fullcontrol = 0;
        row.updatecontrol = 0;
        row.readonlycontrol = 0;
      }
    }
    if (type == 'readonlycontrol') {
      if (event.target.checked) {
        row.fullcontrol = 0;
        row.updatecontrol = 0;
        row.readonlycontrol = 3;
      } else {
        row.fullcontrol = 0;
        row.updatecontrol = 0;
        row.readonlycontrol = 0;
      }
    }

    this.roles.data.forEach(element => {
      if (element.objecttypeid == row.objecttypeid) {
        element.fullcontrol = row.fullcontrol;
        element.updatecontrol = row.updatecontrol;
        element.readonlycontrol = row.readonlycontrol;
      }
    });

    this.roles = new MatTableDataSource(this.roles.data);
    this.changeDetectorRefs.detectChanges();
  }

  roleForm() {
    this.rolesForm = this.fb.group({
      roleName: new FormControl('', [Validators.required, Validators.minLength(1), Validators.maxLength(120), customValidationService.cannotContainSpace]),
      roleDescription: new FormControl('', [Validators.minLength(1), Validators.maxLength(480)])
    });
  }

  // form validation
  get f() {
    return this.rolesForm.controls;
  }

  navigatetoRole() {
    if (this.roleId != null && this.roleId != 0) {
      this.router.navigate(["../../roles"], { relativeTo: this.routerstate });
    } else {
      this.router.navigate(["../roles"], { relativeTo: this.routerstate });
    }
  }

  onSubmit() {
    if (!this.rolesForm.valid) {
      this.webErrorService.customErrors(this.translate.instant('assignPrivileges.nameError1'), true, 'warn')
      return;
    } else {
      let data = this.rolesForm.value;
      if (data.roleName.trim() == "") {
        this.webErrorService.customErrors(this.translate.instant('assignPrivileges.nameError1'), true, 'warn')
        return;
      }
      let assignPriviledges: any = [];
      let i = 0;

      this.roles.data.forEach((element, index) => {
        if (element.fullcontrol != 0 || element.updatecontrol != 0 || element.readonlycontrol != 0) {
          i = 1;
        }
      });

      if (i == 0) {
        this.webErrorService.customErrors(this.translate.instant('assignPrivileges.errMsg1'), true, 'warn')
        return;
      }

      this.roles.data.forEach((element, index) => {
        assignPriviledges.push({
          "featureid": element.objecttypeid || element.featureid,
          "fullcontrol": element.fullcontrol == 1 ? true : false,
          "updatecontrol": element.updatecontrol == 2 ? true : false,
          "readonlycontrol": element.readonlycontrol == 3 ? true : false
        });
      });

      let payload = {
        "roleid": this.roleId == null ? 0 : parseInt(this.roleId),
        "Name": data.roleName,
        "Description": data.roleDescription == null ? '' : data.roleDescription,
        "assignPriviledges": assignPriviledges,
        "isnamemodified": false
      }

      if (this.roleId != null && this.roleId != 0) {
        if (this.roleName != data.roleName) payload.isnamemodified = true;

        this.UserService.updateRoles(payload).subscribe((data) => {
          if (data.success) {
            this.navigatetoRole();
            this.notificationServices.success(this.translate.instant('assignPrivileges.updatedMessage'));
          } else {
            this.webErrorService.customErrors(data.message, true, 'warn')
            return;
          }
        }, (error: any) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      } else {
        this.UserService.addRoles(payload).subscribe((data) => {
          if (data.success) {
            this.navigatetoRole();
            this.notificationServices.success(data.message);
          } else {
            this.webErrorService.customErrors(data.message, true, 'warn')
            return;
          }
        }, (error: any) => {
          this.webErrorService.handleAPIErrors(error, null, true, 'warn');
        });
      }
    }
  }

  back() {
    if (this.roleId != null && this.roleId != 0) {
      this.router.navigate(["../../roles"], { relativeTo: this.routerstate });
    } else {
      this.router.navigate(["../roles"], { relativeTo: this.routerstate });
    }
  }
}
